import React, { Component } from "react";
import moment from "moment";
import {
  Row,
  Col,
  Table,
  Pagination,
  Select,
  Button,
  Icon,
  Input,
  Tooltip,
  DatePicker
} from "antd";
import debounce from "lodash/debounce";
import { strings } from "../../helpers";

const { Option } = Select;
const { Search } = Input;
const { RangePicker } = DatePicker;

class LeadsView extends Component {
  render() {
    const {
      leads,
      allRecords,
      pageNo,
      perPage,
      onPageChange,
      handleChangePageSizeChange,
      clinics,
      fetchClinicsList,
      handleSelectClinic,
      gotoCampaigns,
      filterParams,
      searchText,
      handleSearchText,
      handleSearch,
      handleExportLeads,
      onDateFilterSelect
    } = this.props;

    const columns = [
      {
        title: "Name",
        key: "name",
        width: 150,
        dataIndex: "campaign_name"
      },
      {
        title: "Clinic",
        key: "clinic_name",
        dataIndex: "clinic_name"
      },
      {
        title: "Patient name",
        key: "patient_name",
        render: record => {
          return <div>{`${record.first_name} ${record.last_name}`}</div>;
        }
      },
      {
        title: "Mobile number",
        key: "mobile_number",
        render: record => {
          return <div>{`${record.phone_number}`}</div>;
        }
      },
      {
        title: "Patient email",
        key: "clinic_number",
        width: 200,
        dataIndex: "email"
      },
      {
        title: "Date",
        key: "date",
        render: record => {
          return (
            <div>
              {record.campaign_start_time
                ? moment(record.campaign_start_time).format("DD MMM YYYY")
                : ""}{" "}
              -{" "}
              {record.campaign_end_time
                ? moment(record.campaign_end_time).format("DD MMM YYYY")
                : ""}
            </div>
          );
        }
      }
    ];
    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" align="middle" gutter={16} className="mb-20">
            {filterParams?.campaignId && (
              <Col>
                <Button type="link" size="small" onClick={gotoCampaigns}>
                  <Icon type="left" />
                </Button>
              </Col>
            )}
            <Col className="heading-domain pl-0 mb-0">{`Campaign leads`}</Col>
          </Row>
          <Row className="mb-10" gutter={16} align="bottom" type="flex">
            <Col span={5}>
              <label>{strings.dashboard.searchBy}</label>
              <Search
                value={searchText}
                onChange={handleSearchText}
                placeholder="Patient name, number, email"
                onSearch={handleSearch}
                onPressEnter={handleSearch}
                allowClear
              />
            </Col>
            <Col span={5}>
              <label>Select clinic:</label>
              <Select
                className="full-width"
                showSearch
                filterOption={false}
                onSearch={debounce(fetchClinicsList, 800)}
                onChange={handleSelectClinic}
                allowClear
              >
                {clinics.map((clinic, index) => (
                  <Option key={index} value={clinic.id}>
                    {clinic.name}
                  </Option>
                ))}
              </Select>
            </Col>
            <Col span={5}>
              <label className="filter-by-tag">Filter by date range</label>
              <RangePicker
                format="DD/MM/YYYY"
                minDate={new Date()}
                onChange={onDateFilterSelect}
              />
            </Col>
            <Col>
              <Tooltip title="Export leads">
                <Button
                  size="small"
                  onClick={handleExportLeads}
                  icon="export"
                ></Button>
              </Tooltip>
            </Col>
          </Row>

          <Table pagination={false} dataSource={leads} columns={columns} />

          <div className="pagination-wrapper">
            <div className="total-results-wrap">
              <span className="result-count">{allRecords}</span>
              {allRecords > 1 ? strings.results : strings.result}
            </div>
            {allRecords > 10 && (
              <Pagination
                total={allRecords}
                current={pageNo}
                onChange={onPageChange}
                pageSize={perPage}
                defaultCurrent={pageNo}
                showSizeChanger
                showQuickJumper
                onShowSizeChange={handleChangePageSizeChange}
                pageSizeOptions={[
                  "10",
                  "50",
                  "100",
                  "150",
                  "200",
                  "250",
                  "300",
                  "350",
                  "400",
                  "450",
                  "500"
                ]}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default LeadsView;
